module.exports = __webpack_public_path__ + "img/adress.1630993415105.png";